<template>
  <div>
    <div class="cs-signature">
      <h4 class="cs-signature__heading">Confirmation</h4>
      <label class="cs-signature__text">I confirm these are my chosen selections.</label>
      <div class="cs-signature__wrapper">
        <VueSignaturePad ref="signaturePad"
                         :options="{penColor:'#0C4A57', onBegin}"

        />
        <button class="cs-button cs-button--undo" @click="undoSign"><i class="fas fa-undo"></i></button>
      </div>
      <div class="cs-submit-error" v-if="error">
        {{ error }}
      </div>
    </div>

    <div class="cs-submit">
      <button class="cs-button" @click="submit">
        <i v-if="processing" class="fas fa-spinner fa-spin"></i>
        <span>Submit</span>
      </button>
    </div>
  </div>

</template>

<script>

import { VueSignaturePad } from 'vue-signature-pad';

export default {
  components: { VueSignaturePad },
  props: [ 'processing' ],
  data: function () {
    return {
      error: false
    };
  },
  computed: {},
  methods: {
    undoSign() {
      this.$refs.signaturePad.undoSignature();
    },
    onBegin() {
      this.error = false;
    },
    submit() {
      this.error = this.validate();
      if ( !this.error ) {
        const signature = this.$refs.signaturePad.saveSignature();
        this.$emit( 'submit', signature.data );
      }
    },
    /**
     * Returns an error message, or false if all okay
     * @returns {string|boolean}
     */
    validate() {
      const notSigned = this.$refs.signaturePad.isEmpty();
      if ( notSigned ) {
        return 'Please sign inside the box';
      }
      return false;
    }
  },
  emits: [ 'submit' ],
};
</script>


